import { format } from 'date-fns';
import PropTypes from 'prop-types';
import React from 'react';

import ContentfulImage from '../Common/ContentfulImage';
import { PrimaryLink } from '../Common/Links';
import * as styles from './EventCard.module.css';

const EventCard = ({
  title,
  description,
  date,
  image,
  url,
  ctaLabel,
  vertical = false,
  usesExternalRegistration,
  externalRegistrationUrl,
}) => {
  const eventDate = format(new Date(date), 'MMMM dd, yyyy');
  const ctaUrl = usesExternalRegistration ? externalRegistrationUrl : url;
  return (
    <div className={[styles.card, !vertical ? styles.horizontal : ''].join(' ')}>
      {image && (
        <div>
          <ContentfulImage imageFragment={image} />
        </div>
      )}
      <div>
        {date && <h4>{eventDate}</h4>}
        <h4>{title}</h4>
        <p>{description}</p>
        <PrimaryLink url={ctaUrl} label={ctaLabel || 'Register for the event'} isButton />
      </div>
    </div>
  );
};

EventCard.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  image: PropTypes.object.isRequired,
  url: PropTypes.string.isRequired,
  ctaLabel: PropTypes.string,
};

export default EventCard;
